export default __webpack_public_path__ + "static/media/Resume_Rocco_Luigi_Scarcella.f85c34f8.pdf";